import { InputContentType, OutputContentType } from './content-types';

const supportedVersions = <T extends string[]>(...versions: T) => versions;

export const edenSupportedVersions: {
    [key in InputContentType | OutputContentType]: string[];
} = {
    [InputContentType.NONE]: supportedVersions(),

    [InputContentType.PATCH_BATS_PLAYER_ATTRIBUTES]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_EVENT]: supportedVersions('0.0.0', '0.1.0', '0.2.0', '0.3.0', '0.4.0', '0.5.0'),
    [InputContentType.PATCH_EVENT_SERIES]: supportedVersions('0.0.0', '0.1.0', '0.2.0', '0.4.0'),
    [InputContentType.PATCH_PLAYER]: supportedVersions('0.1.0'),
    [InputContentType.PATCH_PLAYER_FAMILY_RELATIONSHIPS]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_TEAM]: supportedVersions('0.0.0', '0.1.0', '0.2.0'),
    [InputContentType.PATCH_OPPONENT_TEAM]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_BATS_PLAYER_ATTRIBUTES]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_BATS_SCOREKEEPING_DATA]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_BATS_SCOREKEEPING_DATA]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_BATS_SCOREKEEPING_EVENT]: supportedVersions('0.0.0'),
    [InputContentType.POST_PREGAME_DATA]: supportedVersions('0.0.0'),
    [InputContentType.POST_CLIENT_AUTHENTICATE]: supportedVersions('0.0.0'),
    [InputContentType.POST_EVENT]: supportedVersions('0.0.0', '0.1.0', '0.2.0', '0.3.0'),
    [InputContentType.POST_EVENT_SERIES]: supportedVersions('0.0.0', '0.1.0', '0.3.0'),
    [InputContentType.POST_FIREBASE_TOKEN]: supportedVersions('0.0.0'),
    [InputContentType.POST_PLAYER]: supportedVersions('0.2.0'),
    [InputContentType.POST_TEAM]: supportedVersions(
        '0.0.0',
        '0.1.0',
        '0.2.0',
        '0.3.0',
        '0.4.0',
        '0.5.0',
        '0.6.0',
        '0.7.0',
        '0.8.0',
    ),
    [InputContentType.POST_MAXPREPS_TEAM_IMPORT]: supportedVersions('0.0.0'),
    [InputContentType.POST_OPPONENT_TEAM]: supportedVersions('0.0.0'),
    [InputContentType.POST_OPPONENT_TEAM_IMPORT]: supportedVersions('0.0.0'),
    [InputContentType.POST_OPPONENT_TEAM_LEGACY_IMPORT]: supportedVersions('0.0.0'),
    [InputContentType.POST_TEAM_INVITE_RESEND]: supportedVersions('0.0.0'),
    [InputContentType.POST_TEAM_AVATAR_IMAGE]: supportedVersions('0.0.0'),
    [InputContentType.POST_TEAM_IMPORT]: supportedVersions('0.0.0'),
    [InputContentType.POST_USER]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.PUT_TEAM_MANAGER]: supportedVersions('0.0.0'),
    [InputContentType.POST_USER_AUTHENTICATE]: supportedVersions('0.0.0'),
    [InputContentType.POST_USER_AUTHENTICATE_FROM_TOKEN]: supportedVersions('0.0.0'),
    [InputContentType.POST_AUTHENTICATION_PROVIDER_AUTHENTICATE]: supportedVersions('0.0.0'),
    [InputContentType.POST_LOGIN_LINK]: supportedVersions('0.0.0'),
    [InputContentType.PUT_RSVP_RESPONSE]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_PASSWORD]: supportedVersions('0.0.0'),
    [InputContentType.POST_MESSAGING_CHANNEL_IMAGE]: supportedVersions('0.0.0'),
    [InputContentType.POST_MESSAGING_CHANNEL_VIDEO]: supportedVersions('0.0.0'),
    [InputContentType.POST_SIMPLE_SCOREKEEPING_TEAM_CONFIG]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_SIMPLE_SCOREKEEPING_GAME_DATA]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_SIMPLE_SCOREKEEPING_GAME_DATA]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_SIMPLE_SCOREKEEPING_GAME_DATA_AFTER_GAME]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_SIMPLE_SCOREKEEPING_GAME_DATA_AFTER_GAME]: supportedVersions('0.0.0'),
    [InputContentType.POST_SIMPLE_SCOREKEEPING_GAME_TIME]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_TEAM_NOTIFICATION_SETTING]: supportedVersions('0.0.0'),
    [InputContentType.POST_TEAM_HIGH_SCHOOL_INFO]: supportedVersions('0.0.0'),
    [InputContentType.POST_REIMPORT_EXTERNAL_EVENTS]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_BATS_STARTING_LINEUP]: supportedVersions('0.0.0'),
    [InputContentType.POST_BATS_STARTING_LINEUP]: supportedVersions('0.0.0'),
    [InputContentType.PUT_GAME_STAT_EDIT_COLLECTION]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_ROSTER_ROLLOVER]: supportedVersions('0.2.0'),
    [InputContentType.PATCH_ORGANIZATION_SCHEDULE_EVENT]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_ORGANIZATION_SCHEDULE_EVENT]: supportedVersions('0.0.0', '0.1.0'),
    [InputContentType.POST_ORGANIZATION_SCHEDULE_EVENT_BULK]: supportedVersions('0.0.0'),
    [InputContentType.POST_ORGANIZATION_SCHEDULE_EVENT_BULK_VALIDATE]: supportedVersions('0.0.0'),
    [InputContentType.POST_ORGANIZATION_TEAMS]: supportedVersions('0.0.0'),
    [InputContentType.PATCH_STREAM_ASSET_METADATA]: supportedVersions('0.0.0'),
    [InputContentType.POST_TEAM_COMMUNITY_PASS]: supportedVersions('0.0.0'),

    [OutputContentType.BATS_IMPORT_INITIATE]: supportedVersions('0.0.0'),
    [OutputContentType.BATS_PLAYER_ATTRIBUTES]: supportedVersions('0.0.0'),
    [OutputContentType.BATS_SCOREKEEPING_DATA]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.BATS_SCOREKEEPING_EVENT]: supportedVersions('0.0.0'),
    [OutputContentType.BATS_SCOREKEEPING_EVENT_ID]: supportedVersions('0.0.0'),
    [OutputContentType.BATS_USER]: supportedVersions('0.0.0'),
    [OutputContentType.PREGAME_DATA]: supportedVersions('0.0.0'),
    [OutputContentType.CLIENT_TOKEN]: supportedVersions('0.0.0'),
    [OutputContentType.CLIENT_BACKUP]: supportedVersions('0.0.0'),
    [OutputContentType.EVENT]: supportedVersions('0.0.0', '0.1.0', '0.2.0'),
    [OutputContentType.EVENT_SERIES]: supportedVersions('0.0.0'),
    [OutputContentType.FIREBASE_TOKEN]: supportedVersions('0.0.0'),
    [OutputContentType.PERMISSION]: supportedVersions('0.0.0'),
    [OutputContentType.ENTITY_PERMISSION]: supportedVersions('0.0.0'),
    [OutputContentType.SCOPED_PERMISSIONS]: supportedVersions('0.0.0'),
    [OutputContentType.PLAYER]: supportedVersions('0.1.0'),
    [OutputContentType.PUBLIC_TEAM]: supportedVersions('0.0.0'),
    [OutputContentType.PUBLIC_TEAM_PROFILE]: supportedVersions('0.0.0'),
    [OutputContentType.PUBLIC_TEAM_SUMMARY]: supportedVersions('0.0.0', '0.1.0', '0.2.0', '0.3.0'),
    [OutputContentType.RSVP_RESPONSE]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.SUBSCRIPTION_INFORMATION]: supportedVersions('0.1.0', '0.2.0'),
    [OutputContentType.SYNC_CHANNEL_STATE]: supportedVersions('0.0.0'),
    [OutputContentType.SYNC_UPDATE]: supportedVersions('0.0.0'),
    [OutputContentType.GLBOAL_SYNC_UPDATE]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM]: supportedVersions('0.9.0', '0.10.0'),
    [OutputContentType.OPPONENT_TEAM]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_ID]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_INVITE_RESEND]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_MESSAGING_CHANNEL]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_AVATAR_IMAGE]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_FAN]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_SEARCH_RESULT]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.OPPONENT_TEAM_IMPORT_SEARCH_RESULT]: supportedVersions('0.0.0'),
    [OutputContentType.OPPONENT_TEAM_ID]: supportedVersions('0.0.0'),
    [OutputContentType.TWILIO_CHAT_TOKEN]: supportedVersions('0.0.0'),
    [OutputContentType.USER]: supportedVersions('0.0.0', '0.1.0', '0.2.0', '0.2.1', '0.3.0'),
    [OutputContentType.USER_TOKEN]: supportedVersions('0.0.0'),
    [OutputContentType.USER_STATUS]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.EXTERNAL_CALENDAR_SYNC_URL]: supportedVersions('0.0.0'),
    [OutputContentType.MESSAGING_CHANNEL_IMAGE]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.MESSAGING_CHANNEL_VIDEO]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.LOGIN_LINK]: supportedVersions('0.0.0'),
    [OutputContentType.SIMPLE_SCOREKEEPING_CONFIG]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.SIMPLE_SCOREKEEPING_TEAM_CONFIG]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.SIMPLE_SCOREKEEPING_GAME_DATA]: supportedVersions('0.0.0'),
    [OutputContentType.BATCH_SIMPLE_SCOREKEEPING_GAME_DATA_RESULT]: supportedVersions('0.0.0'),
    [OutputContentType.GAME_SUMMARY]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.TEAM_NOTIFICATION_SETTING]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_HIGH_SCHOOL_INFO]: supportedVersions('0.0.0'),
    [OutputContentType.INTEGRATIONS_LITE_TEAM]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_EXTERNAL_ASSOCIATIONS]: supportedVersions('0.0.0'),
    [OutputContentType.REIMPORT_EXTERNAL_EVENTS]: supportedVersions('0.0.0'),
    [OutputContentType.RELATIONSHIP_REQUEST]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_SEASON_STATS]: supportedVersions('0.0.0', '0.1.0', '0.2.0'),
    [OutputContentType.PLAYER_STATS]: supportedVersions('0.0.0'),
    [OutputContentType.PLAYER_GAME_STATS]: supportedVersions('0.0.0'),
    [OutputContentType.USER_TEAM_ASSOCIATIONS]: supportedVersions('0.0.0'),
    [OutputContentType.USER_PLAYER_RELATIONSHIP]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_USER]: supportedVersions('0.0.0'),
    [OutputContentType.EVENT_BEST_STREAM_ID]: supportedVersions('0.0.0', '0.0.1', '0.0.2'),
    [OutputContentType.GAME_STREAM]: supportedVersions('0.0.0', '0.0.1', '0.0.2'),
    [OutputContentType.GAME_STREAM_EVENT]: supportedVersions('0.0.0'),
    [OutputContentType.GAME_STREAM_VIEWER_PAYLOAD_LITE]: supportedVersions('0.0.0'),
    [OutputContentType.BATS_STARTING_LINEUP]: supportedVersions('0.0.0'),
    [OutputContentType.LATEST_BATS_STARTING_LINEUP]: supportedVersions('0.0.0'),
    [OutputContentType.GAME_STAT_EDIT_COLLECTION]: supportedVersions('0.0.0'),
    [OutputContentType.MAXPREPS_SCHOOL_SEARCH_RESULTS]: supportedVersions('0.0.0'),
    [OutputContentType.MAXPREPS_IMPORT_RESULT]: supportedVersions('0.0.0'),
    [OutputContentType.SCHEDULE_EVENT_VIDEO_STREAM]: supportedVersions('0.0.0'),
    [OutputContentType.ORGANIZATION_WITH_ROLE]: supportedVersions('0.0.0', '0.0.1', '0.2.0', '0.3.0', '0.3.1', '0.3.2'),
    [OutputContentType.ORGANIZATION]: supportedVersions('0.0.0', '0.1.0', '0.2.0', '0.2.1'),
    [OutputContentType.ORGANIZATION_TEAM]: supportedVersions('0.0.0', '0.1.0'),
    [OutputContentType.ORGANIZATION_USER_ASSOCIATIONS]: supportedVersions('0.0.0'),
    [OutputContentType.ORGANIZATION_SCHEDULE_EVENT]: supportedVersions('0.0.0'),
    [OutputContentType.ORGANIZATION_SCHEDULE_EVENT_BULK_UPLOAD_TEMPLATE]: supportedVersions('0.0.0'),
    [OutputContentType.ORGANIZATION_SCHEDULE_EVENT_BULK_VALIDATE]: supportedVersions('0.0.0'),
    [OutputContentType.ORGANIZATION_LEADERBOARDS]: supportedVersions('0.0.0'),
    [OutputContentType.ORGANIZATION_SCHEDULE_EVENT_RESULTS_EXPORT]: supportedVersions('0.0.0'),
    [OutputContentType.VIDEO_CLIP_ASSET_METADATA]: supportedVersions('0.0.0'),
    [OutputContentType.VIDEO_CLIP]: supportedVersions('0.0.0'),
    [OutputContentType.VIDEO_STREAM_ASSET_METADATA]: supportedVersions('0.0.0'),
    [OutputContentType.VIDEO_STREAM_ASSET_PLAYBACK_DATA]: supportedVersions('0.0.0'),
    [OutputContentType.VIDEO_STREAM_PLAYBACK_DATA]: supportedVersions('0.0.0'),
    [OutputContentType.ATHLETE_PROFILE_PUBLIC]: supportedVersions('0.0.0'),
    [OutputContentType.ATHLETE_PROFILE_CLIPS_PUBLIC]: supportedVersions('0.0.0'),
    [OutputContentType.ATHLETE_PROFILE_CAREER_STATS_PUBLIC]: supportedVersions('0.0.0'),
    [OutputContentType.TEAM_PUBLIC_PROFILE_ID]: supportedVersions('0.0.0'),
};

export type SupportedVersions = typeof edenSupportedVersions;
